<template>
  <v-container>
    <div
      v-if="enableMelhoresClienteWeb"
      id="headersMelhoresClientes"
    >
      <div
        v-if="loading"
        :style="styleObject"
        class="text-center"
      >
        <v-icon
          light
          class="custom-loader"
          :style="styleObject"
        >
          mdi-cached
        </v-icon>
        Carregando dados...
      </div>
      <div
        v-else-if="error"
        class="alert alert-danger"
      >
        {{ error }}
      </div>
      <div
        v-else
      >
        <div
          id="idTable"
          style="overflow-x: auto; max-width: 100%;"
        >
          <table
            style="width: 100%; table-layout: fixed; color: black; border-collapse: collapse;"
            class="elevation-1"
          >
            <thead>
              <tr>
                <th
                  id="dadoMovimentacaoHeader"
                  style="text-align: center;"
                  class="black--text title"
                >
                  Cliente
                </th>
                <th
                  id="dadoMovimentacaoHeader"
                  style="text-align: center;"
                  class="black--text title"
                >
                  Faturamento
                </th>
                <th
                  id="dadoMovimentacaoHeader"
                  style="text-align: center;"
                  class="black--text title"
                >
                  Quantidade
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="item in melhoresClientes"
                :key="item.id"
              >
                <td
                  id="dadoMovimentacao"
                  style="text-align: left;"
                >
                  {{ item.nome_cliente }}
                </td>
                <td
                  id="dadoMovimentacao"
                  style="text-align: right;"
                >
                  {{ item.faturamento }}
                </td>
                <td
                  id="dadoMovimentacao"
                  style="text-align: right;"
                >
                  {{ item.quantidade }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <router-link
          to="/clientes/detalhe-melhores-clientes-faturado"
          :style="styleObject"
        >
          <div
            id="linkDetalheMelhoresClientes"
            class="text-center"
          >
            <v-icon
              id="iconLinkMelhoresClientes"
              class="text-center"
            >
              mdi-chevron-double-down
            </v-icon><br>
          </div>
        </router-link>
      </div>
    </div>
    <v-row
      v-if="enableMelhoresClientesPrint"
      id="melhoresClientesPrint"
    >
      <v-col cols="12">
        <v-data-table
          :headers="headersMelhoresClientes"
          :items="melhoresClientes"
          :items-per-page="melhoresClientes.length"
          fixed-header
          disable-sort
          hide-default-footer
          class="elevation-1"
          style="color: black"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import Clientes from '../../../../../services/clientes'
  import eventEmit from '../../core/EventoEmit'

  export default {
    name: 'ShowClientesExibicaoMelhores',
    emits: ['envioMelhoresClientes'],
    components: {
    },
    data: () => ({
      styleObject: {
        color: localStorage.corPrimaria,
      },
      loading: false,
      error: null,
      primeiroDia: (new Date(new Date().getFullYear(), new Date().getMonth(), 1)).toISOString().substr(0, 10),
      ultimoDia: (new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).toISOString().substr(0, 10),
      select: [],
      vendedorSelect: [],
      areaSelect: [],
      redeSelect: [],
      supervisorSelect: [],
      receita: [],
      segmento: [],
      categoria: [],
      promotor: [],
      headersMelhoresClientes: [
        { text: 'Cliente', value: 'nome_cliente', class: 'black--text title' },
        { text: 'Fat. Anual Acumulado', value: 'faturamento', align: 'right', class: 'black--text title' },
        { text: 'Quant. Anual Acumulado', value: 'quantidade', align: 'right', class: 'black--text title' },
      ],
      melhoresClientes: [],
      enableMelhoresClientesPrint: false,
      enableMelhoresClienteWeb: true,
    }),

    created () {
      eventEmit.$on('set_faturamento_novos_clientes', this.handleUpdateDados)

      eventEmit.$on('enable-print', this.handleEnablePrint)

      eventEmit.$on('disable-print', this.handleDisablePrint)
    },

    beforeDestroy () {
      eventEmit.$off('set_faturamento_novos_clientes', this.handleUpdateDados)

      eventEmit.$off('enable-print', this.handleEnablePrint)

      eventEmit.$off('disable-print', this.handleDisablePrint)
    },

    methods: {
      handleUpdateDados (primeiroDia, dataFinal, select, vendedor, area, rede, supervisor, receita, segmento, categoria, promotor) {
        this.primeiroDia = primeiroDia
        this.ultimoDia = dataFinal
        this.select = select
        this.vendedorSelect = vendedor
        this.areaSelect = area
        this.redeSelect = rede
        this.supervisorSelect = supervisor
        this.receita = receita
        this.segmento = segmento
        this.categoria = categoria
        this.promotor = promotor

        this.showDadosMelhoresClientes()
      },

      handleEnablePrint (value) {
        this.enableMelhoresClientesPrint = value
        this.enableMelhoresClienteWeb = false
      },

      handleDisablePrint (value) {
        this.enableMelhoresClientesPrint = false
        this.enableMelhoresClienteWeb = value
      },

      async showDadosMelhoresClientes () {
        this.loading = true
        this.melhoresClientes = []

        await Clientes.showMelhoresClientes(this.primeiroDia, this.ultimoDia, this.select, localStorage.tokencontrato, this.vendedorSelect, this.areaSelect, this.redeSelect, this.supervisorSelect, this.receita, this.segmento, this.categoria, this.promotor).then(resposta => {
          if (resposta.data.status) {
            this.melhoresClientes = resposta.data.dadosMelhoresClientes.map((item) => {
              var listaMelhoresClientes = ({
                nome_cliente: item.nome_cliente,
                faturamento: item.faturamento.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                quantidade: item.quantidade,
              })
              return listaMelhoresClientes
            })
          } else if (resposta.data.msg === 'Não há dados no período selecionado') {
            this.melhoresClientes = []

            this.showSnackbar('error', 3000, resposta.data.msg)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => {
          this.loading = false

          eventEmit.$emit('envio-melhores-clientes', this.headersMelhoresClientes, this.melhoresClientes)
        })
      },
    },
  }
</script>

<style scoped>
  .custom-loader {
    animation: loader 1s infinite;
    display: flex;
    @-moz-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-webkit-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-o-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)
  }

  @media screen
  and (min-device-width : 320px)
  and (max-device-width : 680px) {
    #headersMelhoresClientes {
      width: 100% !important;
    }

    #idTable {
      max-height: 500px;
    }

    #dadoMovimentacao {
      font-size: 8.5px;
    }

    th, td {
      padding: 8px;
      word-wrap: break-word;
      white-space: normal;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  @media screen
  and (min-width : 681px)
  and (max-width : 960px)
  and (-webkit-min-device-pixel-ratio: 1) {
    #headersMelhoresClientes {
      width: 100% !important;
    }
  }

  #idTable {
    overflow-x: auto;
    overflow-y: auto;
    max-height: 600px;
  }

   #dadoMovimentacao {
    font-size: 12px;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    font-family: Roboto, sans-serif;
    border: 1px solid #e0e0e0;
  }

  thead th {
    position: sticky;
    top: 0;
    z-index: 2;
    background-color: #f5f5f5;
  }

  th, td {
    border: 1px solid #e0e0e0;
    padding: 10px;
    color: #424242;
    word-wrap: break-word;
    white-space: normal;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  thead {
    background-color: #f5f5f5;
  }

  tbody tr:hover {
    background-color: #f0f0f0;
  }

  #dadoMovimentacaoHeader {
    font-size: 12px !important;
    font-weight: 800 !important;
  }
</style>
